import { render, staticRenderFns } from "./ReminderPlanFilter.vue?vue&type=template&id=1be73146&"
import script from "./ReminderPlanFilter.vue?vue&type=script&lang=js&"
export * from "./ReminderPlanFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports